<div *ngIf="validationMessages">
  <div *ngFor="let message of validationMessages">
    <small class="text-red-500" *ngIf="control.hasError(message.type)">
      {{message.message}}
    </small>
  </div>
</div>
